module.exports = __webpack_public_path__ + "img/wechat.c3da8e7e.png";